<fury-page-layout mode="card">
    <fury-page-layout-header>
        <div class="header_vew">
            <fury-breadcrumbs current="View Claim"></fury-breadcrumbs>
            <div class="top_heading">
            
                <div class="btn_panel">
                    <button mat-raised-button class="deepred" (click)="openActionModal('assignOrEditTechnician')">
                        <span>
                            Assign Technician
                        </span>
                     </button>
                    <button mat-raised-button class="green" *ngIf="claimDetails?.claim?.isTechnicianAssigned" (click)="openActionModal('addTechnicianSchedule')">
                        <span>
                            Add Appointment
                        </span>
                     </button>
                     <button mat-raised-button class="orenge" (click)="openActionModal('uploadDiagnosis')">
                        <span>
                            Add Diagnosis
                        </span>
                     </button>
                     <button mat-raised-button class="deepblue" (click)="openActionModal('addOutcome')">
                        <span>
                            Add Outcome
                        </span>
                     </button>
                     <button mat-raised-button class="deepgreen" (click)="handleAddComplaint()">
                        <span>
                        Add Complaint
                        </span>
                     </button>
                     <button mat-raised-button class="deepyellow" (click)="openActionModal('escalateClaim')">
                        <span>
                            Escalate Claim
                        </span>
                     </button>
                     <button mat-raised-button class="sky" (click)="openActionModal('addPayout')">
                        <span>
                            Add Payout
                        </span>
                     </button>
                     <button mat-raised-button class="deepviolet" (click)="openActionModal('orderReplacement')">
                        <span>
                            Add Replacement
                        </span>
                     </button>
                     <button mat-raised-button class="deepredviolet" (click)="handleAddNotes()">
                        <span>
                            Add Notes
                        </span>
                     </button>
                     <button mat-raised-button class="new_blue" (click)="handleAddSpecialRequest()">
                        <span>
                            Add Special Request
                        </span>
                     </button>
                     <button mat-raised-button class="softgreen" (click)="handleAddFeedback()">
                        <span>
                            Add Feedback
                        </span>
                     </button>
                </div>
    
                <div>
                    
                      <button mat-button class="can-button"
                    (click)="back()"><mat-icon>keyboard_backspace</mat-icon> Back</button>
                </div>
                
            </div>
        </div>
        
    </fury-page-layout-header>
    <div class="lebel_section">
        <fury-common-label-section [mainPage]="'viewClaim'"></fury-common-label-section>
    </div>
    <fury-page-layout-content [@fadeInUp]>
        <div class="two_section">
            <div class="customer_leftinfo">
                <fury-claims-side-menu [fetchSideMenu]="fetchSideMenu"></fury-claims-side-menu>
            </div>
            <div class="righpanel">
                
                <div class="block_area">
                    <fury-common-kpi-blocks [mainPage]="'viewClaims'" [data]="claimKpi"></fury-common-kpi-blocks>
                </div>
                <!-- <div class="view_panel" *ngIf="!isEditClaim && validClaim"> -->
                <div class="view_panel">
                    <div class="panel_heading underline">
                            <h2>
                                Claim Information
                            </h2>
                            <div class="panel_editsection">
                                <mat-icon *ngIf="editingTab !== allSections.ClaimInfo" (click)="editSection(allSections.ClaimInfo)" class="edit_icon">edit</mat-icon>
                                <mat-icon *ngIf="editingTab === allSections.ClaimInfo" (click)="cancelSection(allSections.ClaimInfo)" class="cancel_icon">close</mat-icon>
                                <mat-icon *ngIf="editingTab === allSections.ClaimInfo" (click)="saveSection(allSections.ClaimInfo)" class="done_icon">done</mat-icon>
                            </div>
                    </div>
                    <div class="claim_showprt" *ngIf="editingTab !== allSections.ClaimInfo">
                        <div class="claim_inputprt">
                            <label>
                                Claim Number
                            </label>
                            <p>
                                {{claimDetails?.claim?.fileClaimNumber}}

                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Created Date
                            </label>
                            <p>
                                {{commonService.convertDate(claimDetails?.claim?.createdAt) | date : 'MMM dd, YYYY'}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Created By
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.agentDetail?.firstName,
                                claimDetails?.claim?.agentDetail?.lastName)}}
                            </p>
                        </div>



                        <div class="claim_inputprt">
                            <label>
                                Claim Status
                            </label>
                            <p>
                                {{claimDetails?.claim?.status}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Copayment
                            </label>
                            <p>
                                {{claimDetails?.claim?.copaymentFee | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Copayment Paid
                            </label>
                            <p>
                                {{claimDetails?.claim?.isPaid ? "Paid" : "Pending"}}
                            </p>
                        </div>

                  

                        <div class="claim_inputprt">
                            <label>
                                Payout Method
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.paymentMethod}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Emergency
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.emergency ? "Yes" : "No"}}
                            </p>
                        </div>

                  

                        <div class="claim_inputprt">
                            <label>
                                Assigned Concierge
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.additionalInfo?.assignedConcierge?.firstName,
                                claimDetails?.claim?.additionalInfo?.assignedConcierge?.lastName)}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Assigned Coordinator Time stamp
                            </label>
                            <p>
                                {{commonService.convertDate(claimDetails?.claim?.additionalInfo?.assignedTimeStamp) | date : 'MMM dd, YYYY h:mm a' }}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Outcome Score
                            </label>
                            <p>
                                {{claimDetails?.claim?.decision?.outcomeScore}}
                            </p>
                        </div>

                       

                        <div class="claim_inputprt">
                            <label>
                                Outcome Closed By
                            </label>
                            <p>
                               
                                {{commonService.getFullName(claimDetails?.claim?.decision?.outcomeClosedBy?.firstName,
                                    claimDetails?.claim?.decision?.outcomeClosedBy?.lastName)}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Outcome Closed On
                            </label>
                            <p>
                                {{claimDetails?.claim?.decision?.outcomeClosedOn | date:
                                    'MMM dd, YYYY'}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Warranty Period
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.warrantyPeriod}}
                            </p>
                        </div>

                        <div class="claim_inputprt full-width">
                            <label>
                                Copayment Notes
                            </label>
                            <p>
                                {{claimDetails?.claim?.copayNotes}}
                            </p>
                        </div>


                        <div class="claim_inputprt full-width">
                            <label>
                                Status Notes
                            </label>
                            <p>
                                {{claimDetails?.claim?.statusNotes}}
                            </p>
                        </div>

                        <div class="claim_inputprt full-width">
                            <label>
                                Notes
                            </label>
                            <p>
                                {{claimDetails?.claim?.decision?.claimOutcomeNote}}
                            </p>
                        </div>
                    </div>
                    
                    <ng-container  *ngIf="editingTab === allSections.ClaimInfo">
                        <form [formGroup]="claimInfoForm">
                            <div class="claim_showprt">
                                <div class="claim_inputprt">
                                    <label>
                                        Claim Number
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.fileClaimNumber}}
        
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Created Date
                                    </label>
                                    <p>
                                        {{commonService.convertDate(claimDetails?.claim?.createdAt) | date : 'MMM dd, YYYY'}}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Created By
                                    </label>
                                    <p>
                                        {{commonService.getFullName(claimDetails?.claim?.agentDetail?.firstName,
                                        claimDetails?.claim?.agentDetail?.lastName)}}
                                    </p>
                                </div>
        
        
        
                                <div class="claim_inputprt">
                                    <label>
                                        Claim Status
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.status}}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Copayment
                                    </label>
                                    <span>
                                        <input formControlName="copaymentFee"  mask="separator.2" prefix="$" thousandSeparator=","/>
                                    </span>
                                    <mat-error  *ngIf="claimInfoForm.controls['copaymentFee'].touched && claimInfoForm.controls['copaymentFee'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
        
                                <div class="claim_inputprt">
                                    <label>
                                        Copayment Paid
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.isPaid ? "Paid" : "Pending"}}
                                    </p>
                                </div>
        
                          
        
                                <div class="claim_inputprt">
                                    <label>
                                        Payout Method
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.additionalInfo?.paymentMethod}}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                       Emergency
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                            <mat-select matNativeControl formControlName="emergency">
                                                <mat-option [value]="true">Yes</mat-option>
                                                <mat-option [value]="false">No</mat-option>
                                            </mat-select>
                                            <mat-error  *ngIf="claimInfoForm.controls['emergency'].touched && claimInfoForm.controls['emergency'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                          </mat-form-field>
                                    </span>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Assigned Concierge
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                            <mat-select matNativeControl formControlName="assignedConcierge">
                                                <mat-option *ngFor="let item of agents"
                                                    value="{{item?.userId}}">{{commonService.getFullName(item?.firstName,
                                                    item?.lastName)}}</mat-option>
                                            </mat-select>
                                            <mat-error  *ngIf="claimInfoForm.controls['assignedConcierge'].touched && claimInfoForm.controls['assignedConcierge'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                          </mat-form-field>
                                    </span>
                                </div>
        
                                <div class="claim_inputprt">
                                    <label>
                                        Assigned Coordinator Time stamp
                                    </label>
                                    <p>
                                        {{commonService.convertDate(claimDetails?.claim?.additionalInfo?.assignedTimeStamp) | date : 'MMM dd, YYYY h:mm a' }}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Outcome Score
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                       <mat-select matNativeControl formControlName="outcomeScore">
                                        <mat-option *ngFor="let item of outcomeScoreList"
                                            [value]="item">{{item}}</mat-option>
                                    </mat-select>
                                    <mat-error  *ngIf="claimInfoForm.controls['outcomeScore'].touched && claimInfoForm.controls['outcomeScore'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                    </mat-form-field>
                                    </span>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Outcome Closed By
                                    </label>
                                    <p>
                                       
                                        {{commonService.getFullName(claimDetails?.claim?.decision?.outcomeClosedBy?.firstName,
                                            claimDetails?.claim?.decision?.outcomeClosedBy?.lastName)}}
                                    </p>
                                </div>
        
                                <div class="claim_inputprt">
                                    <label>
                                        Outcome Closed On
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.decision?.outcomeClosedOn | date:
                                            'MMM dd, YYYY'}}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Warranty Period
                                    </label>

                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                       <mat-select matNativeControl formControlName="warrantyPeriod">
                                        <mat-option *ngFor="let item of warrantyList"
                                            [value]="item">{{item}}</mat-option>
                                    </mat-select>
                                    <mat-error  *ngIf="claimInfoForm.controls['warrantyPeriod'].touched && claimInfoForm.controls['warrantyPeriod'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                    </mat-form-field>
                                    </span>
                                </div>

                                <div class="claim_inputprt full-width">
                                    <label>
                                        Copayment Notes
                                    </label>
                                    <span>
                                         <textarea formControlName="copaymentNotes"></textarea>
                                    </span>
                                    <mat-error  *ngIf="claimInfoForm.controls['copaymentNotes'].touched && claimInfoForm.controls['copaymentNotes'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Status Notes
                                    </label>
                                    <span>
                                         <textarea formControlName="statusNotes"></textarea>
                                    </span>
                                    <mat-error  *ngIf="claimInfoForm.controls['statusNotes'].touched && claimInfoForm.controls['statusNotes'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Notes
                                    </label>
                                    <span>
                                         <textarea formControlName="claimOutcomeNote"></textarea>
                                    </span>
                                    <mat-error  *ngIf="claimInfoForm.controls['claimOutcomeNote'].touched && claimInfoForm.controls['claimOutcomeNote'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>

                            </div>
        
                         </form>
                    </ng-container>
                    <div class="gap"></div>

                    <div class="panel_heading underline" [ngClass]="{'claimwrap': editingTab !== allSections.ClaimFollowUp && !claimSectionVisible?.followUp}">
                        <h2>
                            Claim Follow Up
                        </h2>
                        <div class="panel_editsection">
                            <mat-icon *ngIf="editingTab !== allSections.ClaimFollowUp  && !!claimSectionVisible?.followUp " (click)="editSection(allSections.ClaimFollowUp)" class="edit_icon">edit</mat-icon>
                            <button class="add_button" mat-stroked-button *ngIf="editingTab !== allSections.ClaimFollowUp && !claimSectionVisible?.followUp" (click)="editingTab = allSections.ClaimFollowUp"><mat-icon>add_circle</mat-icon> Add Claim Follow Up</button>
                            <mat-icon *ngIf="editingTab === allSections.ClaimFollowUp" (click)="cancelSection(allSections.ClaimFollowUp)" class="cancel_icon">close</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.ClaimFollowUp" (click)="saveSection(allSections.ClaimFollowUp)" class="done_icon">done</mat-icon>
                        </div>
                        
                    </div>
                    



                    <div class="claim_showprt"  *ngIf="editingTab !== allSections.ClaimFollowUp && !!claimSectionVisible?.followUp">

                        <div class="claim_inputprt">
                            <label>
                                Assigned Agent
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.additionalInfo?.assignedFollowUpAgent?.firstName,claimDetails?.claim?.additionalInfo?.assignedFollowUpAgent?.lastName)}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Status
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.followUpStatus}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Closed By
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.additionalInfo?.followUpClosedBy?.firstName,
                                    claimDetails?.claim?.additionalInfo?.followUpClosedBy?.lastName)}}
    
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Closed on
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.followUpClosedOn | date:
                                    'MMM dd, YYYY'}}
                            </p>
                        </div>

                    </div>

                    <div class="claim_showprt no-data" *ngIf="editingTab !== allSections.ClaimFollowUp && !claimSectionVisible?.followUp">
                        No data found
                    </div>

                    <ng-container  *ngIf="editingTab === allSections.ClaimFollowUp">
                        <form [formGroup]="followUpForm">
                            <div class="claim_showprt">
                                <div class="claim_inputprt">
                                    <label>
                                        Assigned Agent
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                            <mat-select matNativeControl formControlName="assignedFollowUpAgent">
                                                <mat-option *ngFor="let item of agents"
                                                    value="{{item?.userId}}">{{commonService.getFullName(item?.firstName,
                                                    item?.lastName)}}</mat-option>
                                            </mat-select>
                                            <mat-error  *ngIf="followUpForm.controls['assignedFollowUpAgent'].touched && followUpForm.controls['assignedFollowUpAgent'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                          </mat-form-field>
                                    </span>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Status
                                    </label>
                                    <span>
                                          <mat-form-field appearance="outline" class="select_panel">
                                            <mat-select matNativeControl formControlName="followUpStatus">
                                                <mat-option value="New">New</mat-option>
                                                <mat-option value="Completed">Completed</mat-option>
                                            </mat-select>
                                            <mat-error  *ngIf="followUpForm.controls['followUpStatus'].touched && followUpForm.controls['followUpStatus'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                          </mat-form-field>
                                    </span>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Closed By
                                    </label>
                                    <p>
                                        {{commonService.getFullName(claimDetails?.claim?.additionalInfo?.followUpClosedBy?.firstName,
                                            claimDetails?.claim?.additionalInfo?.followUpClosedBy?.lastName)}}
            
                                    </p>
                                </div>
        
                                <div class="claim_inputprt">
                                    <label>
                                        Closed on
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.additionalInfo?.followUpClosedOn | date:
                                            'MMM dd, YYYY'}}
                                    </p>
                                </div>
                            </div>
        
                         </form>
                    </ng-container>
                
                    <div class="gap"></div>
                    <h2 class="underline">
                        Account Executive
                    </h2>
                    <div class="claim_showprt">

                        <div class="claim_inputprt">
                            <label>
                             Name
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.agreementDetail?.agentDetail?.firstName,claimDetails?.claim?.agreementDetail?.agentDetail?.lastName)}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Email Address
                            </label>
                            <p>
                                {{claimDetails?.claim?.agreementDetail?.agentDetail?.emailAddress}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Phone Number
                            </label>
                            <p>
                                {{claimDetails?.claim?.agreementDetail?.agentDetail?.phoneNumber | mask: '(000) 000-0000'}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Ext
                            </label>
                            <p>
                                {{claimDetails?.claim?.agreementDetail?.agentDetail?.ext}}
                            </p>
                        </div>

                    </div>
                    <div class="gap"></div>
                    <h2 class="underline">
                        Agreement Information
                    </h2>
                    <div class="claim_showprt">

                        <div class="claim_inputprt">
                            <label>
                                Agreement Number
                            </label>
                            <p>
                                {{ claimDetails?.claim?.agreementDetail?.agreementNumber }}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Purchase Date
                            </label>
                            <p>
                                {{ commonService.convertDate(claimDetails?.claim?.agreementDetail?.agreementPurchaseDate)  | date : 'MMM dd, YYYY' }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Agreement Status
                            </label>
                            <p>
                                {{ claimDetails?.claim?.agreementDetail?.status }}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Sold By
                            </label>
                            <p>
                                {{commonService.getFullName( claimDetails?.claim?.agreementDetail?.firstName,
                                claimDetails?.claim?.agreementDetail?.lastName)}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Days Active
                            </label>
                            <p>
                                {{commonService.daysActive(claimDetails?.claim?.agreementDetail?.agreementEffectiveDate)}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Days Remaining
                            </label>
                            <p>
                                {{commonService.daysRemaining(claimDetails?.claim?.agreementDetail?.agreementExpireDate)}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Agreement Cost
                            </label>
                            <p>
                                {{claimDetails?.claim?.agreementDetail?.subTotalAmount | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Agreement Type
                            </label>
                            <p>
                                {{claimDetails?.claim?.agreementDetail?.pricingOption}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Total Received
                            </label>
                            <p>
                                {{claimDetails?.claim?.agreementDetail?.netReceived | currency}}
                            </p>
                        </div>

                    </div>
                    <div class="gap"></div>
                    <h2 class="underline">Claim Statistics</h2>
                    <div class="claim_showprt">
                        <div class="claim_inputprt">
                            <label>
                                Total Claims
                            </label>
                            <p>
                                {{claimDetails?.claimInfoByAgreement?.totalClaim}}
                            </p>
                        </div>
                        
                        <div class="claim_inputprt">
                            <label>
                                Approved Claims
                            </label>
                            <p>
                                {{claimDetails?.claimInfoByAgreement?.approvedClaims}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Denied Claims
                            </label>
                            <p>
                                {{claimDetails?.claimInfoByAgreement?.deniedClaims}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Gain/Loss
                            </label>
                            <p>
                                {{claimDetails?.claimInfoByAgreement?.gainOrLoss | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Covered Address
                            </label>
                            <p>
                                {{commonService.getStreetAddress(claimDetails?.claim?.agreementDetail?.coveredAddress)}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Property Type
                            </label>
                            <p>
                                {{claimDetails?.claim?.agreementDetail?.orderPlanDetail?.orderPropertyTypeName}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Property Size
                            </label>
                            <p>
                                {{claimDetails?.claim?.agreementDetail?.orderPlanDetail?.orderPropertySizeName}}
                            </p>
                        </div>

                    </div>

                    <div class="gap"></div>
                    <h2 class="underline">
                        Customer Information
                    </h2>


                    <div class="claim_showprt">

                        <div class="claim_inputprt">
                            <label>
                                First Name
                            </label>
                            <p>
                                {{claimDetails?.claim?.firstName}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Last Name
                            </label>
                            <p>
                                {{claimDetails?.claim?.lastName}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Address
                            </label>
                            <p>
                                {{commonService.getStreetAddress(claimDetails?.claim?.propertyAddress)}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Phone Number
                            </label>
                            <p>
                                {{claimDetails?.claim?.phoneNumber | mask: '(000) 000-0000'}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Secondary Number
                            </label>
                            <p>
                                {{claimDetails?.claim?.secondaryPhoneNumber | mask: '(000) 000-0000'}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Email Address
                            </label>
                            <p>
                                {{claimDetails?.claim?.emailAddress}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Secondary Email Address
                            </label>
                            <p>
                                {{claimDetails?.claim?.secondaryEmailAddress}}
                            </p>
                        </div>

                    </div>
                    <div class="gap"></div>

                    <h2 class="underline">
                        Customer Stats
                    </h2>


                    <div class="claim_showprt">

                        <div class="claim_inputprt">
                            <label>
                                Total # of Agreements
                            </label>
                            <p>
                                {{claimDetails?.customerStats?.totalAgreement}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Total Paid
                            </label>
                            <p>
                                {{claimDetails?.customerStats?.totalPaidOut | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Total Claims filed
                            </label>
                            <p>
                                {{claimDetails?.customerStats?.totalClaimsFiled}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Approved Claims
                            </label>
                            <p>
                                {{claimDetails?.customerStats?.approvedClaims}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Denied Claims
                            </label>
                            <p>
                                {{claimDetails?.customerStats?.deniedClaims}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Gain/Loss
                            </label>
                            <p>
                                {{claimDetails?.customerStats?.gainOrLoss | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Assigned Coordinators
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.additionalInfo?.assignedCoordinator?.firstName,
                                    claimDetails?.claim?.additionalInfo?.assignedCoordinator?.lastName)}} , {{claimDetails?.claim?.additionalInfo?.assignedCoordinatorDatetime |date:
                                        'MMM dd, YYYY'}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Created By
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.agentDetail?.firstName,
                                    claimDetails?.claim?.agentDetail?.lastName)}} 
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Assigned Concierge
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.additionalInfo?.assignedConcierge?.firstName,
                                    claimDetails?.claim?.additionalInfo?.assignedConcierge?.lastName)}} , {{claimDetails?.claim?.additionalInfo?.assignedConciergeDatetime |date:
                                        'MMM dd, YYYY'}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Assigned Supervisor
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.additionalInfo?.assignedSupervisor?.firstName,
                                    claimDetails?.claim?.additionalInfo?.assignedSupervisor?.lastName)}} , {{claimDetails?.claim?.additionalInfo?.assignedConciergeDatetime |date:
                                        'MMM dd, YYYY'}}
                            </p>
                        </div>


                    </div>

                    <div class="gap"></div>

                    <div class="panel_heading underline" [ngClass]="{'claimwrap': editingTab !== allSections.ContactInformation && !claimSectionVisible?.contactInformation}">
                            <h2>
                            Contact Information
                            </h2>
                            <div class="panel_editsection">
                                <mat-icon *ngIf="editingTab !== allSections.ContactInformation && !!claimSectionVisible?.contactInformation" (click)="editSection(allSections.ContactInformation)" class="edit_icon">edit</mat-icon>
                                <button class="add_button" mat-stroked-button *ngIf="editingTab !== allSections.ContactInformation && !claimSectionVisible?.contactInformation" (click)="editingTab = allSections.ContactInformation"><mat-icon>add_circle</mat-icon> Add Contact Information</button>
                                <mat-icon *ngIf="editingTab === allSections.ContactInformation" (click)="cancelSection(allSections.ContactInformation)" class="cancel_icon">close</mat-icon>
                                <mat-icon *ngIf="editingTab === allSections.ContactInformation" (click)="saveSection(allSections.ContactInformation)" class="done_icon">done</mat-icon>
                            </div>
                    </div>
                    <div class="claim_showprt" *ngIf="editingTab !== allSections.ContactInformation && !!claimSectionVisible?.contactInformation">

                        <div class="claim_inputprt">
                            <label>
                                Contact Person
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.contactPerson}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                 Phone Number
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.contactPhoneNumber | mask: '(000) 000-0000'}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Email Address
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.contactEmailAddress}}
                            </p>
                        </div>

                    </div>
                    <div class="claim_showprt no-data"  *ngIf="editingTab !== allSections.ContactInformation && !claimSectionVisible?.contactInformation">
                        No data found
                    </div>

                    <ng-container  *ngIf="editingTab === allSections.ContactInformation">
                        <form [formGroup]="contactInfoForm">
                            <div class="claim_showprt">
                                <div class="claim_inputprt">
                                    <label>
                                        Contact Person
                                    </label>
                                    <span>
                                        <input formControlName="contactPerson" />
                                    </span>
                                    <mat-error  *ngIf="contactInfoForm.controls['contactPerson'].touched && contactInfoForm.controls['contactPerson'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Phone Number
                                    </label>
                                    <span>
                                        <input type="text" formControlName="contactPhoneNumber" mask="(000) 000-0000" />
                                        <mat-error  *ngIf="contactInfoForm.controls['contactPhoneNumber'].touched && contactInfoForm.controls['contactPhoneNumber'].hasError('required')">
                                            This is required field.
                                        </mat-error>
                                        <mat-error  *ngIf="contactInfoForm.controls['contactPhoneNumber'].touched && contactInfoForm.controls['contactPhoneNumber'].hasError('mask')">
                                            Enter valid phone number.
                                        </mat-error>
                                    </span>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Email Address
                                    </label>
                                    <span>
                                        <input formControlName="contactEmailAddress" />
                                        <mat-error  *ngIf="contactInfoForm.controls['contactEmailAddress'].touched && contactInfoForm.controls['contactEmailAddress'].hasError('required')">
                                            This is required field.
                                        </mat-error>
                                        <mat-error  *ngIf="contactInfoForm.controls['contactEmailAddress'].touched && contactInfoForm.controls['contactEmailAddress'].hasError('pattern')">
                                            Enter valid email address.
                                        </mat-error>
                                    </span>
                                </div>
                            </div>
        
                         </form>
                    </ng-container>
                    <div class="gap"></div>
                    <h2 class="underline">
                        Coverage Benefits
                    </h2>


                    <div class="claim_showprt">

                        <div class="claim_inputprt">
                            <label>
                                Days Active
                            </label>
                            <p>
                                {{commonService.daysActive(claimDetails?.claim?.agreementDetail?.agreementEffectiveDate)}}
                            
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Covered Item
                            </label>
                            <p>
                                {{claimDetails?.claim?.coveredItem}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Item Age
                            </label>
                            <p>
                                {{claimDetails?.coverageBenefits?.ageOfTheItem}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Coverage Benefits
                            </label>
                            <p>
                                {{claimDetails?.coverageBenefits?.coverageBenefits | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Available Benefits
                            </label>
                            <p>
                                {{claimDetails?.coverageBenefits?.availableBenefits | currency}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Total Previously Paid
                            </label>
                            <p>
                                {{claimDetails?.agreementDetail?.netReceived | currency}}
                            </p>
                        </div>

                    </div>
                    <div class="gap"></div>

                    <div class="panel_heading underline">
                        <h2>
                            Claim Summary
                        </h2>
                        <div class="panel_editsection">
                            <mat-icon *ngIf="editingTab !== allSections.ClaimSummary" (click)="editSection(allSections.ClaimSummary)" class="edit_icon">edit</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.ClaimSummary" (click)="cancelSection(allSections.ClaimSummary)" class="cancel_icon">close</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.ClaimSummary" (click)="saveSection(allSections.ClaimSummary)" class="done_icon">done</mat-icon>
                        </div>  
                    </div>
                    <div *ngIf="editingTab !== allSections.ClaimSummary" class="claim_showprt">
                        <div class="claim_inputprt full-width">
                            <label>
                                Notes
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.claimSummaryNote}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Covered Item
                            </label>
                            <p>
                                {{claimDetails?.claim?.coveredItem}}
                            </p>
                        </div>

                      


                        <div class="claim_inputprt">
                            <label>
                                Issue Notes
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.issueNote}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Prior Issue information
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.priorIssueInformation}}
                            </p>
                        </div>

         



                        <div class="claim_inputprt">
                            <label>
                                90 Days Limitations
                            </label>
                            <p>
                                {{!!claimDetails?.claim?.additionalInfo?.ninetyDayLimitation ? "Active": "Inactive"}}
                            </p>
                        </div>
                        <ng-container *ngFor="let item of claimDetails?.claim?.firstQestions" >
                        <div class="claim_inputprt">
                            <label>
                                {{item?.question_details?.title}}
                            </label>
                            <p>
                                {{item?.question_details?.type == "Yes/No" ? (item.answer ?
                                'Yes' : 'No') : item?.answer}}
                            </p>
                        </div>
                    </ng-container>

                    <ng-container *ngFor="let item of claimDetails?.claim?.additionalQuestions" >
                        <div class="claim_inputprt">
                            <label>
                                {{item?.question_details?.title}}
                            </label>
                            <p>
                                {{item?.question_details?.type === 'Yes/No' ? (item.answer ? 'Yes' : 'No') :
                                item?.question_details?.type === 'Date' ? (item?.answer | date:
                                'MMM dd, YYYY') :
                                item?.answer}}
                            </p>
                        </div>
                    </ng-container>

                    
                    <ng-container *ngFor="let item of claimDetails?.claim?.answerDetails" >
                        <div class="claim_inputprt full-width itemquestion">
                            <label>
                                {{item.claim_question_answer_details[0]?.quetion?.question}}
                            </label>
                            <div class="itemflex">
                                <p *ngFor="let answer of item?.claim_question_answer_details">
                                    {{answer?.answer}}</p>
                                <p *ngIf="claimDetails?.claim?.otherAnswer">{{claimDetails?.claim?.otherAnswer}}</p>
                            </div>
                           
                        </div>
                    </ng-container>

                    
                    <div class="claim_inputprt">
                        <label>
                            When did you first notice the issue?
                        </label>
                        <p>
                            {{ commonService.convertDate(claimDetails?.claim?.issueDate)   | date : 'MMM dd, YYYY'}}
                        </p>
                    </div>



                        
                        
                    </div>
                    <ng-container  *ngIf="editingTab === allSections.ClaimSummary">
                        <form [formGroup]="claimSummaryForm">
                            <div class="claim_showprt">
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Notes
                                    </label>
                                    <span>
                                         <textarea formControlName="claimSummaryNote"></textarea>
                                    </span>
                                    <mat-error  *ngIf="claimSummaryForm.controls['claimSummaryNote'].touched && claimSummaryForm.controls['claimSummaryNote'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Issue Note
                                    </label>
                                    <span>
                                         <textarea formControlName="issueNote"></textarea>
                                    </span>
                                    <mat-error  *ngIf="claimSummaryForm.controls['issueNote'].touched && claimSummaryForm.controls['issueNote'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Covered Item
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.coveredItem}}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Prior Issue information
                                    </label>
                                    <span>
                                        <input formControlName="priorIsuueInformation"/>
                                    </span>
                                    <mat-error  *ngIf="claimSummaryForm.controls['priorIsuueInformation'].touched && claimSummaryForm.controls['priorIsuueInformation'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        90 Days Limitations
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                       <mat-select matNativeControl formControlName="ninetyDayLimitation">
                                        <mat-option value="1">Active</mat-option>
                                        <mat-option value="0">Inactive</mat-option>
                                    </mat-select>
                                    </mat-form-field>
                                    </span>
                                    <mat-error  *ngIf="claimSummaryForm.controls['ninetyDayLimitation'].touched && claimSummaryForm.controls['ninetyDayLimitation'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                
                            </div>
        
                        </form>
                        <!-- ***** Additional question Form ***** -->
                        <div class="form_prt">
                            <form [formGroup]="additionalQuestionForm">
                              <div class="claim_showprt">
                                <div class="questioprt" *ngFor="let question of additionalQuestion; index as i">
                                    
                                        <label>{{ question?.question_details?.title }}</label>
                                        <div *ngIf="question?.question_details.type === 'Text Input'" class="text_input">
                                            <input type="text" placeholder="Please provide details" [formControlName]="question?.question_details?.additionalQuestionId">
                                            <mat-error
                                            *ngIf="additionalQuestionForm.controls[question?.question_details?.additionalQuestionId]?.touched && additionalQuestionForm.controls[question?.question_details?.additionalQuestionId].hasError('required')">
                                            This is required
                                            </mat-error>
                                        </div>
                                   
                                  
                                  <div class="radioprt" *ngIf="question?.question_details.type === 'Yes/No'">
                                    <div>
                                      <span><input type="radio" [formControlName]="question?.question_details?.additionalQuestionId" [value]="true"> Yes</span>
                                      <span><input type="radio" [formControlName]="question?.question_details?.additionalQuestionId" [value]="false"> No</span>
                                    </div>
                    
                                    <mat-error
                                      *ngIf="additionalQuestionForm.controls[question?.question_details?.additionalQuestionId]?.touched && additionalQuestionForm.controls[question?.question_details?.additionalQuestionId].hasError('required')">
                                      This is required
                                    </mat-error>
                                  </div>
                                  <div  *ngIf="question?.question_details?.type === 'Date'" class="text_input datapick viewdatapick">
                                    <mat-form-field class="datepicker" appearance="outline">
                                        <input matInput [matDatepicker]="picker" [formControlName]="question?.question_details?.additionalQuestionId" [max]="maxDate" (click)="picker.open()" [readonly]="true" placeholder="Select date">
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                    <mat-error
                                      *ngIf="additionalQuestionForm.controls[question?.question_details?.additionalQuestionId]?.touched && additionalQuestionForm.controls[question?.question_details?.additionalQuestionId].hasError('required')">
                                      This is required
                                    </mat-error>
                                  </div>
                    
                                  <div *ngIf="question?.question_details?.type === 'Dropdown'" class="text_input">
                                    <mat-form-field appearance="outline" class="select_panel">
                                        <mat-select matNativeControl [formControlName]="question?.question_details?.additionalQuestionId">
                                         <mat-option value="">Please select an option</mat-option>
                                         <mat-option *ngFor="let option of question?.question_details?.options" [value]="option?.option">{{option.option}}</mat-option>
                                     </mat-select>
                                     </mat-form-field>
                        
                                    <mat-error
                                      *ngIf="additionalQuestionForm.controls[question?.question_details?.additionalQuestionId]?.touched && additionalQuestionForm.controls[question?.question_details?.additionalQuestionId].hasError('required')">
                                      This is required
                                    </mat-error>
                                  </div>
                                </div>
                              </div>
                            </form>
                        </div>
                        <div class="step">
                            <form [formGroup]="firstQuestionsForm">
                              <div class="claim_showprt">
                                <div class="questioprt" *ngFor="let question of firstQuestions;let i = index">
                                    <label>{{ question?.question_details?.title }}</label>
                                    <div *ngIf="question?.question_details?.type === 'Text Input'" class="text_input">
                                      <input type="text" placeholder="Enter question" [formControlName]="question?.question_details?.firstQuestionId">
                                      <mat-error
                                        *ngIf="firstQuestionsForm.controls[question?.question_details?.firstQuestionId]?.touched && firstQuestionsForm.controls[question?.question_details?.firstQuestionId].hasError('required')">
                                        This is required
                                      </mat-error>
                                    </div>
                                    <div class="radioprt" *ngIf="question?.question_details.type === 'Yes/No'">
                                      <div class="radio_sec">
                                        <span><input type="radio" [formControlName]="question?.question_details?.firstQuestionId" [value]="true"> Yes</span>
                                        <span><input type="radio" [formControlName]="question?.question_details?.firstQuestionId" [value]="false"> No</span>
                                      </div>
                                      <mat-error
                                        *ngIf="firstQuestionsForm.controls[question?.question_details?.firstQuestionId]?.touched && firstQuestionsForm.controls[question?.question_details?.firstQuestionId].hasError('required')">
                                        This is required
                                      </mat-error>
                                    </div>
                                    
                                    <div class="text_input" *ngIf="question?.question_details?.type === 'Dropdown'">
                                        <mat-form-field appearance="outline" class="select_panel">
                                            <mat-select matNativeControl [formControlName]="question?.question_details?.firstQuestionId">
                                             <mat-option value="">Please select an option</mat-option>
                                             <mat-option *ngFor="let option of question?.question_details?.options" [value]="option">{{option}}</mat-option>
                                         </mat-select>
                                         </mat-form-field>
                                      <mat-error
                                        *ngIf="firstQuestionsForm.controls[question?.question_details?.firstQuestionId]?.touched && firstQuestionsForm.controls[question?.question_details?.firstQuestionId].hasError('required')">
                                        This is required
                                      </mat-error>
                                    </div> 
                                </div>
                              </div>
                            </form>
                        </div>
                        <div class="step">
                            <form [formGroup]="claimQuestionForm">
                                <div class="claim_showprt">
                                    <div class="questioprt" *ngFor="let question of claimQuestions">
                                        <label>{{question?.claim_question_answer_details[0]?.quetion?.question}}</label>
                                        <div>
                                            <mat-form-field appearance="outline" class="select_panel">
                                                <mat-select [formControlName]="question?.claim_question_answer_details[0].quetion.claimQuestionId" multiple>
                                                  <mat-option *ngFor="let answer of claimQuestionAnswers" [value]="answer?.claimQuestionAnswerId">{{answer?.answer}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </ng-container>

                     <div class="gap"></div>
                     
                    <div *ngFor="let item of claimDetails?.claim?.scheduleAppointment; let i = index">
                        <div class="panel_heading underline claimwrap">
                            <h2>
                                Scheduled Appointment - <span>[{{i+1}}]</span>
                            </h2>
                            <div class="panel_editsection">
                                <button class="add_button" mat-stroked-button (click)="openActionModal('addTechnicianSchedule')" ><mat-icon>add_circle</mat-icon>Add Appointment</button>
                            </div>
                        </div>
                        
                        <div class="claim_showprt">
                            <div class="claim_inputprt">
                                <label>
                                    Created By
                                </label>
                                <p>

                                    {{commonService.getFullName(item?.assignedBy?.firstName,
                                    item?.assignedBy?.lastName)}}

                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Assigned Coordinator
                                </label>
                                <p>

                                    {{commonService.getFullName(item?.assignedCoordinator?.firstName,
                                    item?.assignedCoordinator?.lastName)}}

                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Assigned Concierge
                                </label>
                                <p>

                                    {{commonService.getFullName(claimDetails?.claim?.additionalInfo?.assignedConcierge?.firstName,
                                    claimDetails?.claim?.additionalInfo?.assignedConcierge?.lastName)}}

                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Assigned Coordinator Time stamp
                                </label>
                                <p>

                                    {{ commonService.convertDate(item?.assignedCoordinatorDatetime)   | date : 'MMM dd, YYYY h:mm a'}}

                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Time of Appointment
                                </label>
                                <p>

                                    {{  commonService.convertDate(item?.timeOfAppointment)  | date : 'MMM dd, YYYY h:mm a'}}

                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Arrival Window
                                </label>
                                <p>

                                    {{item?.arrivalWindow}}

                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Assigned Company
                                </label>
                                <p>

                                    {{item?.assignedTechnician?.company?.companyName}}

                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Technician Name
                                </label>
                                <p>

                                    {{commonService.getFullName(item?.assignedTechnician?.firstName,
                                    item?.assignedTechnician?.lastName)}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Technician Phone Number
                                </label>
                                <p>

                                    {{item?.assignedTechnician?.phoneNumber | mask: '(000) 000-0000'}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Technician Email
                                </label>
                                <p>

                                    {{item?.assignedTechnician?.emailAddress}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Service Fee
                                </label>
                                <p>

                                    {{item?.assignedTechnician?.titleAgencySettings?.diagnostic?.serviceFee | currency}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Applied to Repair
                                </label>
                                <p>

                                    {{item?.appliedToRepair ? "Yes" : "No"}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Scheduled Appointment Notes
                                </label>
                                <p>

                                    {{item?.scheduledAppointmentNote}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Technician Ratings
                                </label>
                                <p>

                                    {{item?.technicianRatings}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Customer Availability
                                </label>
                                <p>
                                    {{claimDetails?.claim?.availability}}
                                </p>
                            </div>

                        </div>
                    </div>

                    <div class="gap"></div>
                    <div class="panel_heading underline" [ngClass]="{'claimwrap': editingTab !== allSections.Diagnosis && !claimSectionVisible?.diagnosis}">
                        <h2>
                            Diagnosis
                        </h2>
                        <div class="panel_editsection">
                            <mat-icon *ngIf="editingTab !== allSections.Diagnosis && !!claimSectionVisible?.diagnosis" (click)="editSection(allSections.Diagnosis)" class="edit_icon">edit</mat-icon>
                            <button class="add_button" mat-stroked-button *ngIf="editingTab !== allSections.Diagnosis && !claimSectionVisible?.diagnosis" (click)="editingTab = allSections.Diagnosis"><mat-icon>add_circle</mat-icon> Add Diagnosis</button>
                            <mat-icon *ngIf="editingTab === allSections.Diagnosis" (click)="cancelSection(allSections.Diagnosis)" class="cancel_icon">close</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.Diagnosis" (click)="saveSection(allSections.Diagnosis)" class="done_icon">done</mat-icon>
                        </div>
                    </div>
                    <div *ngIf="editingTab !== allSections.Diagnosis && !!claimSectionVisible?.diagnosis" class="claim_showprt">
                        <div class="claim_inputprt full-width">
                            <label>
                                Notes
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.notes}}
                            </p>
                        </div>

                        <div class="claim_inputprt full-width">
                            <label>
                                Recommendation
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.recommendation}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Estimated Cost of Parts
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.costOfRepair?.parts | currency}}
                            </p>
                        </div>



                        <div class="claim_inputprt">
                            <label>
                                Estimated Cost of Labor
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.costOfRepair?.labor  | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Total Estimated Cost
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.costOfRepair?.total  | currency}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Age of Item
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.ageOfItem}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Item Type
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.itemType}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Brand
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.brand}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Model #
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.model}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Serial #
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.serial}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Color
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.color}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Size
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.size}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Add a note
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.documentNote}}
                            </p>
                        </div>
                       

                        

                        <div class="claim_inputprt">
                            <label>
                                Diagnosis timestamp
                            </label>
                            <p>
                                {{commonService.convertDate(claimDetails?.claim?.diagnosis?.createdAt) | date : 'MMM dd, YYYY h:mm a'}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Diagnosis added by
                            </label>
                            <p>

                                {{commonService.getFullName(claimDetails?.claim?.diagnosis?.diagnosisAddedBy?.firstName,
                                    claimDetails?.claim?.diagnosis?.diagnosisAddedBy?.lastName)}}
                    
                            </p>
                        </div>

                        
                        <div class="claim_inputprt full-width">
                            <label>
                                What was Completed ?
                            </label>
                            <p>
                                {{claimDetails?.claim?.diagnosis?.whatWasCompleted}}
                            </p>
                        </div>



                    </div>

                    <div class="claim_showprt no-data" *ngIf="editingTab !== allSections.Diagnosis && !claimSectionVisible?.diagnosis">
                        No data found
                    </div>
                    <ng-container  *ngIf="editingTab === allSections.Diagnosis">
                        <form [formGroup]="diagnosisForm">
                            <div class="claim_showprt">
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Notes
                                    </label>
                                    <span>
                                         <textarea formControlName="notes"></textarea>
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['notes'].touched && diagnosisForm.controls['notes'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Recomendation
                                    </label>
                                    <span>
                                         <textarea formControlName="recommendation"></textarea>
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['recommendation'].touched && diagnosisForm.controls['recommendation'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Estimated Cost of Parts
                                    </label>
                                    <span>
                                       <input formControlName="costOfRepairParts"  mask="separator.2" prefix="$" thousandSeparator=","/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['costOfRepairParts'].touched && diagnosisForm.controls['costOfRepairParts'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Estimated Cost of Labor
                                    </label>
                                    <span>
                                       <input formControlName="costOfRepairLabor"  mask="separator.2" prefix="$" thousandSeparator=","/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['costOfRepairLabor'].touched && diagnosisForm.controls['costOfRepairLabor'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Total Estimated Cost
                                    </label>
                                    <span>
                                       <input formControlName="costOfRepairTotal"  mask="separator.2" prefix="$" thousandSeparator=","/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['costOfRepairTotal'].touched && diagnosisForm.controls['costOfRepairTotal'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Age of Item
                                    </label>
                                    <span>
                                       <input formControlName="ageOfItem"/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['ageOfItem'].touched && diagnosisForm.controls['ageOfItem'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Item Type
                                    </label>
                                    <span>
                                       <input formControlName="itemType"/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['itemType'].touched && diagnosisForm.controls['itemType'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Brand
                                    </label>
                                    <span>
                                       <input formControlName="brand"/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['brand'].touched && diagnosisForm.controls['brand'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Model #
                                    </label>
                                    <span>
                                       <input formControlName="model"/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['model'].touched && diagnosisForm.controls['model'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Serial #
                                    </label>
                                    <span>
                                       <input formControlName="serial"/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['serial'].touched && diagnosisForm.controls['serial'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Color
                                    </label>
                                    <span>
                                       <input formControlName="color"/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['color'].touched && diagnosisForm.controls['color'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Size
                                    </label>
                                    <span>
                                       <input formControlName="size"/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['size'].touched && diagnosisForm.controls['size'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Add a note
                                    </label>
                                    <span>
                                       <input formControlName="documentNote"/> 
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['documentNote'].touched && diagnosisForm.controls['documentNote'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Diagnosis timestamp
                                    </label>
                                    <p>
                                        {{commonService.convertDate(claimDetails?.claim?.diagnosis?.createdAt) | date : 'MMM dd, YYYY h:mm a'}}
                                    </p>
                                </div>
        
                                <div class="claim_inputprt">
                                    <label>
                                        Diagnosis added by
                                    </label>
                                    <p>
        
                                        {{commonService.getFullName(claimDetails?.claim?.diagnosis?.diagnosisAddedBy?.firstName,
                                            claimDetails?.claim?.diagnosis?.diagnosisAddedBy?.lastName)}}
                            
                                    </p>
                                </div>
                                <div class="claim_inputprt full-width">
                                    <label>
                                        What was Completed ?
                                    </label>
                                    <span>
                                         <textarea formControlName="whatWasCompleted"></textarea>
                                    </span>
                                    <mat-error  *ngIf="diagnosisForm.controls['whatWasCompleted'].touched && diagnosisForm.controls['whatWasCompleted'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                            </div>
        
                        </form>
                    </ng-container>

                    <div class="gap"></div>
                    <div class="panel_heading underline" [ngClass]="{'claimwrap': editingTab !== allSections.ClaimDecision && !claimSectionVisible?.decision}">
                        <h2>
                            Claim Decision
                        </h2>
                        <div class="panel_editsection">
                            <mat-icon *ngIf="editingTab !== allSections.ClaimDecision && !!claimSectionVisible?.decision" (click)="editSection(allSections.ClaimDecision)" class="edit_icon">edit</mat-icon>
                            <button class="add_button" mat-stroked-button *ngIf="editingTab !== allSections.ClaimDecision && !claimSectionVisible?.decision" (click)="editingTab = allSections.ClaimDecision"><mat-icon>add_circle</mat-icon> Add Claim Decision</button>
                            <mat-icon *ngIf="editingTab === allSections.ClaimDecision" (click)="cancelSection(allSections.ClaimDecision)" class="cancel_icon">close</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.ClaimDecision" (click)="saveSection(allSections.ClaimDecision)" class="done_icon">done</mat-icon>
                        </div>  
                    </div>
                    <div *ngIf="editingTab !== allSections.ClaimDecision && !!claimSectionVisible?.decision" class="claim_showprt">
                        <div class="claim_inputprt full-width">
                            <label>
                                Note
                            </label>
                            <p>
                                {{claimDetails?.claim?.decision?.claimOutcomeNote}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Claims Outcome
                            </label>
                            <p>
                                {{claimDetails?.claim?.decision?.claimOutcome}}
                            </p>
                        </div>

                        

                        <div class="claim_inputprt">
                            <label>
                                Outcome Timestamp
                            </label>
                            <p>
                                {{commonService.convertDate(claimDetails?.claim?.decision?.createdAt) | date :'MMM dd, YYYY h:mm a'}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Status
                            </label>
                            <p>
                                {{claimDetails?.claim?.decision?.outcomeStatus}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Outcome Score
                            </label>
                            <p>
                                {{claimDetails?.claim?.decision?.outcomeScore}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Closed By
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.decision?.outcomeClosedBy?.firstName,
                                claimDetails?.claim?.decision?.outcomeClosedBy?.lastName)}}
                            </p>
                        </div>


                        <div class="claim_inputprt">
                            <label>
                                Closed on
                            </label>
                            <p>
                                {{commonService.convertDate(claimDetails?.claim?.decision?.outcomeClosedOn) | date :
                                'MMM dd, YYYY'}}
                            </p>
                        </div>
                    </div>

                    <div class="claim_showprt no-data" *ngIf="editingTab !== allSections.ClaimDecision && !claimSectionVisible?.decision">
                        No data found
                    </div>
                    <ng-container  *ngIf="editingTab === allSections.ClaimDecision">
                        <form [formGroup]="claimDecisionForm">
                            <div class="claim_showprt">
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Notes
                                    </label>
                                    <span>
                                         <textarea formControlName="claimOutcomeNote"></textarea>
                                    </span>
                                    <mat-error  *ngIf="claimDecisionForm.controls['claimOutcomeNote'].touched && claimDecisionForm.controls['claimOutcomeNote'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Claim Outcome
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                       <mat-select matNativeControl formControlName="claimOutcome">
                                        <mat-option *ngFor="let item of claimOutcomeList"
                                            [value]="item">{{item}}</mat-option>
                                    </mat-select>
                                    </mat-form-field>
                                    </span>
                                    <mat-error  *ngIf="claimDecisionForm.controls['claimOutcome'].touched && claimDecisionForm.controls['claimOutcome'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Outcome Timestamp
                                    </label>
                                    <p>
                                        {{commonService.convertDate(claimDetails?.claim?.decision?.createdAt) | date :'MMM dd, YYYY h:mm a'}}
                                    </p>
                                </div>
        
        
                                <div class="claim_inputprt">
                                    <label>
                                        Status
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                       <mat-select matNativeControl formControlName="outcomeStatus">
                                        <mat-option *ngFor="let item of claimDecisionStatus"
                                            [value]="item">{{item}}</mat-option>
                                    </mat-select>
                                    <mat-error  *ngIf="claimDecisionForm.controls['outcomeStatus'].touched && claimDecisionForm.controls['outcomeStatus'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                    </mat-form-field>
                                    </span>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Outcome Score
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                       <mat-select matNativeControl formControlName="outcomeScore">
                                        <mat-option *ngFor="let item of outcomeScoreList"
                                            [value]="item">{{item}}</mat-option>
                                    </mat-select>
                                    <mat-error  *ngIf="claimDecisionForm.controls['outcomeScore'].touched && claimDecisionForm.controls['outcomeScore'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                    </mat-form-field>
                                    </span>
                                </div>
        
                                <div class="claim_inputprt">
                                    <label>
                                        Closed By
                                    </label>
                                    <p>
                                        {{commonService.getFullName(claimDetails?.claim?.decision?.outcomeClosedBy?.firstName,
                                        claimDetails?.claim?.decision?.outcomeClosedBy?.lastName)}}
                                    </p>
                                </div>
        
        
                                <div class="claim_inputprt">
                                    <label>
                                        Closed on
                                    </label>
                                    <p>
                                        {{commonService.convertDate(claimDetails?.claim?.decision?.outcomeClosedOn) | date :
                                        'MMM dd, YYYY'}}
                                    </p>
                                </div>
                              
                            </div>
        
                        </form>
                    </ng-container>
                    <div class="gap"></div>
                    <div class="panel_heading underline" [ngClass]="{'claimwrap': editingTab !== allSections.AssignSupervisor && !claimSectionVisible?.escalation}">
                        <h2>
                            Claim Escalation
                        </h2>
                        <div class="panel_editsection">
                            <mat-icon *ngIf="editingTab !== allSections.AssignSupervisor && !!claimSectionVisible?.escalation" (click)="editSection(allSections.AssignSupervisor)" class="edit_icon">edit</mat-icon>
                            <button class="add_button" mat-stroked-button *ngIf="editingTab !== allSections.AssignSupervisor && !claimSectionVisible?.escalation" (click)="editingTab = allSections.AssignSupervisor"><mat-icon>add_circle</mat-icon> Add Claim Escalation</button>
                            <mat-icon *ngIf="editingTab === allSections.AssignSupervisor" (click)="cancelSection(allSections.AssignSupervisor)" class="cancel_icon">close</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.AssignSupervisor" (click)="saveSection(allSections.AssignSupervisor)" class="done_icon">done</mat-icon>
                        </div>  
                    </div>
                    <div *ngIf="editingTab !== allSections.AssignSupervisor && !!claimSectionVisible?.escalation" class="claim_showprt">

                        <div class="claim_inputprt">
                            <label>
                                Assigned Supervisor
                            </label>
                            <p>
                                {{commonService.getFullName(claimDetails?.claim?.additionalInfo?.assignedSupervisor?.firstName,
                                claimDetails?.claim?.additionalInfo?.assignedSupervisor?.lastName)}}

                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Requested On
                            </label>
                            <p>
                                {{ commonService.convertDate(claimDetails?.claim?.additionalInfo?.escalationRequestedOn)   | date : 'MMM dd, YYYY' }}
                            </p>
                        </div>

                        <div class="claim_inputprt full-width">
                            <label>
                                Note
                            </label>
                            <p>
                                {{claimDetails?.claim?.additionalInfo?.assignedSupervisorNote}}

                            </p>
                        </div>

                    </div>
                    <div class="claim_showprt no-data" *ngIf="editingTab !== allSections.AssignSupervisor && !claimSectionVisible?.escalation">
                        No data found
                    </div>
                    <ng-container  *ngIf="editingTab === allSections.AssignSupervisor">
                        <form [formGroup]="assignSupervisorForm">
                            <div class="claim_showprt">
                                <div class="claim_inputprt">
                                    <label>
                                        Assigned Supervisor
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                            <mat-select matNativeControl formControlName="assignedSupervisor">
                                                <mat-option *ngFor="let item of agents"
                                                    value="{{item?.userId}}">{{commonService.getFullName(item?.firstName,
                                                    item?.lastName)}}</mat-option>
                                            </mat-select>
                                            <mat-error  *ngIf="assignSupervisorForm.controls['assignedSupervisor'].touched && assignSupervisorForm.controls['assignedSupervisor'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                          </mat-form-field>
                                    </span>
                                </div>
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Notes
                                    </label>
                                    <span>
                                         <textarea formControlName="assignedSupervisorNote"></textarea>
                                    </span>
                                    <mat-error  *ngIf="assignSupervisorForm.controls['assignedSupervisorNote'].touched && assignSupervisorForm.controls['assignedSupervisorNote'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                
                            </div>
        
                        </form>
                    </ng-container>
                    <div class="gap"></div>

                    <h2 class="underline">
                        Claim Payout
                    </h2>
                    <div>
                        <div class="payout_panel">
                            <div class="panel_heading underline" [ngClass]="{'claimwrap': editingTab !== allSections.TechniciaPayout && !claimSectionVisible?.technicianPayout}">
                                <h2>
                                 Technician Payout
                                </h2>
                                <div class="panel_editsection">
                                    <mat-icon *ngIf="editingTab !== allSections.TechniciaPayout && !!claimSectionVisible?.technicianPayout" (click)="editSection(allSections.TechniciaPayout)" class="edit_icon">edit</mat-icon>
                                    <button class="add_button" mat-stroked-button *ngIf="editingTab !== allSections.TechniciaPayout && !claimSectionVisible?.technicianPayout" (click)="editingTab = allSections.TechniciaPayout"><mat-icon>add_circle</mat-icon> Add Technician Payout</button>
                                    <mat-icon *ngIf="editingTab === allSections.TechniciaPayout" (click)="cancelSection(allSections.TechniciaPayout)" class="cancel_icon">close</mat-icon>
                                    <mat-icon *ngIf="editingTab === allSections.TechniciaPayout" (click)="saveSection(allSections.TechniciaPayout)" class="done_icon">done</mat-icon>
                                </div>
                            </div>
                            <div *ngIf="editingTab !== allSections.TechniciaPayout && !!claimSectionVisible?.technicianPayout" class="claim_showprt">
                                <div class="claim_inputprt full-width">
                                    <label>
                                         Notes
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.technicianPayoutNotes}}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Payout Amount
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.technicianPayout | currency}}
                                    </p>
                                </div>
    
                                <div class="claim_inputprt">
                                    <label>
                                         Status
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.technicianPayoutStatus}}
                                    </p>
                                </div>
    
                                <div class="claim_inputprt">
                                    <label>
                                      Dates
                                    </label>
                                    <p>
                                        {{ commonService.convertDate(claimDetails?.claim?.claimPayout?.technicianPayoutDatetime)  | date : 'MMM dd, YYYY h:mm a'}}
                                    </p>
                                </div>
    
                                <div class="claim_inputprt">
                                    <label>Payment Method
                                        
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.technicianPayoutPaymentMethod}}
                                    </p>
                                </div>
    
                                <div class="claim_inputprt">
                                    <label>
                                         Transaction id
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.technicianPayoutTransactionId}}
                                    </p>
                                </div>
    
                                
                            </div>
                            <div class="claim_showprt no-data" *ngIf="editingTab !== allSections.TechniciaPayout && !claimSectionVisible?.technicianPayout">
                                No data found
                            </div>

                            <ng-container  *ngIf="editingTab === allSections.TechniciaPayout">
                                <form [formGroup]="technicianPayoutForm">
                                    <div class="claim_showprt">
                                        <div class="claim_inputprt full-width">
                                            <label>
                                                Notes
                                            </label>
                                            <span>
                                                 <textarea formControlName="technicianPayoutNotes"></textarea>
                                            </span>
                                            <mat-error  *ngIf="technicianPayoutForm.controls['technicianPayoutNotes'].touched && technicianPayoutForm.controls['technicianPayoutNotes'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Payout Amount
                                            </label>
                                            <span>
                                               <input formControlName="technicianPayout"  mask="separator.2" prefix="$" thousandSeparator=","/> 
                                            </span>
                                            <mat-error  *ngIf="technicianPayoutForm.controls['technicianPayout'].touched && technicianPayoutForm.controls['technicianPayout'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Status
                                            </label>
                                            <span>
                                                <mat-form-field appearance="outline" class="select_panel">
                                               <mat-select matNativeControl formControlName="technicianPayoutStatus">
                                                <mat-option *ngFor="let item of technicianAndCustomerStatus"
                                                    [value]="item">{{item}}</mat-option>
                                            </mat-select>
                                            </mat-form-field>
                                            </span>
                                            <mat-error  *ngIf="technicianPayoutForm.controls['technicianPayoutStatus'].touched && technicianPayoutForm.controls['technicianPayoutStatus'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Date
                                            </label>
                                            <span>
                                               <mat-form-field fxFlex="auto" appearance="outline"  class="select_panel">
                                                <!-- <mat-label>Technician Schedule Date and Time</mat-label> -->
                                                <input matInput [ngxMatDatetimePicker]="picker1" placeholder="Choose a date and time" formControlName="technicianPayoutDatetime"
                                                  [min]="datePicker.minDate" [disabled]="datePicker.disabled" readonly (click)="picker1.open()">
                                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #picker1 [showSpinners]="datePicker.showSpinners" [showSeconds]="datePicker.showSeconds"
                                                  [stepHour]="datePicker.stepHour" [stepMinute]="datePicker.stepMinute" [stepSecond]="datePicker.stepSecond" [touchUi]="datePicker.touchUi"
                                                  [color]="datePicker.color" [enableMeridian]="datePicker.enableMeridian">
                                                </ngx-mat-datetime-picker>
                                                <mat-error
                                                    *ngIf="data?.formGroup.controls['technicianPayoutDatetime'].touched && data?.formGroup.controls['technicianPayoutDatetime'].hasError('required')">
                                                    This is required field.
                                                </mat-error>
                                                <mat-error
                                                *ngIf="data?.formGroup.controls['technicianPayoutDatetime'].touched && data?.formGroup.controls['technicianPayoutDatetime'].hasError('notValid')">
                                                Selected date and time should be greater than current date and time.
                                            </mat-error>
                                              </mat-form-field>
                                            </span>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Payment Method
                                            </label>
                                            <span>
                                                <mat-form-field appearance="outline" class="select_panel">
                                               <mat-select matNativeControl formControlName="technicianPayoutPaymentMethod">
                                                <mat-option *ngFor="let item of technicianAndCustomerPaymentMethod"
                                                    [value]="item?.value">{{item?.label}}</mat-option>
                                            </mat-select>
                                            <mat-error  *ngIf="technicianPayoutForm.controls['technicianPayoutPaymentMethod'].touched && technicianPayoutForm.controls['technicianPayoutPaymentMethod'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                            </mat-form-field>
                                            </span>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Transaction id
                                            </label>
                                            <span>
                                               <input formControlName="technicianPayoutTransactionId"/> 
                                            </span>
                                            <mat-error  *ngIf="technicianPayoutForm.controls['technicianPayoutTransactionId'].touched && technicianPayoutForm.controls['technicianPayoutTransactionId'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                    </div>
                
                                </form>
                            </ng-container>
                        </div>
                        

                        <div class="payout_panel">
                            <div class="panel_heading underline" [ngClass]="{'claimwrap': editingTab !== allSections.CustomerPayout && !claimSectionVisible?.customerPayout}">
                                <h2>
                                 Customer Payout
                                </h2>
                                <div class="panel_editsection">
                                    <mat-icon *ngIf="editingTab !== allSections.CustomerPayout  && !!claimSectionVisible?.customerPayout" (click)="editSection(allSections.CustomerPayout)" class="edit_icon">edit</mat-icon>
                                    <button class="add_button" mat-stroked-button *ngIf="editingTab !== allSections.CustomerPayout && !claimSectionVisible?.customerPayout" (click)="editingTab = allSections.CustomerPayout"><mat-icon>add_circle</mat-icon> Add Customer Payout</button>
                                    <mat-icon *ngIf="editingTab === allSections.CustomerPayout" (click)="cancelSection(allSections.CustomerPayout)" class="cancel_icon">close</mat-icon>
                                    <mat-icon *ngIf="editingTab === allSections.CustomerPayout" (click)="saveSection(allSections.CustomerPayout)" class="done_icon">done</mat-icon>
                                </div>
                            </div>
                            <div *ngIf="editingTab !== allSections.CustomerPayout && !!claimSectionVisible?.customerPayout" class="claim_showprt">
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Notes
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.customerPayoutNotes}}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Payout Amount
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.customerApprovedAmount | currency}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Status
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.customerPayoutStatus}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                    Date
                                    </label>
                                    <p>
                                        {{ commonService.convertDate(claimDetails?.claim?.claimPayout?.customerPayoutDatetime)   | date : 'MMM dd, YYYY h:mm a'}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                    Payment Method
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.customerPayoutPaymentMethod}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                    Transaction id
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.customerPayoutTransactionId}}
                                    </p>
                                </div>

                                
                            </div>
                            <div class="claim_showprt no-data" *ngIf="editingTab !== allSections.CustomerPayout && !claimSectionVisible?.customerPayout">
                                No data found
                            </div>


                            <ng-container  *ngIf="editingTab === allSections.CustomerPayout">
                                <form [formGroup]="customerPayoutForm">
                                    <div class="claim_showprt">
                                        <div class="claim_inputprt full-width">
                                            <label>
                                                Notes
                                            </label>
                                            <span>
                                                 <textarea formControlName="customerPayoutNotes"></textarea>
                                            </span>
                                            <mat-error  *ngIf="customerPayoutForm.controls['customerPayoutNotes'].touched && customerPayoutForm.controls['customerPayoutNotes'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Payout Amount
                                            </label>
                                            <span>
                                               <input formControlName="customerApproveAmount"  mask="separator.2" prefix="$" thousandSeparator=","/> 
                                            </span>
                                            <mat-error  *ngIf="customerPayoutForm.controls['customerApproveAmount'].touched && customerPayoutForm.controls['customerApproveAmount'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Status
                                            </label>
                                            <span>
                                                <mat-form-field appearance="outline" class="select_panel">
                                               <mat-select matNativeControl formControlName="customerPayoutStatus">
                                                <mat-option *ngFor="let item of technicianAndCustomerStatus"
                                                    [value]="item">{{item}}</mat-option>
                                            </mat-select>
                                            </mat-form-field>
                                            </span>
                                            <mat-error  *ngIf="customerPayoutForm.controls['customerPayoutStatus'].touched && customerPayoutForm.controls['customerPayoutStatus'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Date
                                            </label>
                                            <span>
                                               <!-- <input formControlName="customerPayoutDatetime"/>  -->
                                               <mat-form-field fxFlex="auto" appearance="outline"  class="select_panel">
                                                <!-- <mat-label>Technician Schedule Date and Time</mat-label> -->
                                                <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date and time" formControlName="customerPayoutDatetime"
                                                  [min]="datePicker.minDate" [disabled]="datePicker.disabled" readonly (click)="handleDateOpen()">
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #picker [showSpinners]="datePicker.showSpinners" [showSeconds]="datePicker.showSeconds"
                                                  [stepHour]="datePicker.stepHour" [stepMinute]="datePicker.stepMinute" [stepSecond]="datePicker.stepSecond" [touchUi]="datePicker.touchUi"
                                                  [color]="datePicker.color" [enableMeridian]="datePicker.enableMeridian">
                                                </ngx-mat-datetime-picker>
                                                <mat-error
                                                    *ngIf="data?.formGroup.controls['customerPayoutDatetime'].touched && data?.formGroup.controls['customerPayoutDatetime'].hasError('required')">
                                                    This is required field.
                                                </mat-error>
                                                <mat-error
                                                *ngIf="data?.formGroup.controls['customerPayoutDatetime'].touched && data?.formGroup.controls['customerPayoutDatetime'].hasError('notValid')">
                                                Selected date and time should be greater than current date and time.
                                            </mat-error>
                                              </mat-form-field>
                                            </span>
                                            <mat-error  *ngIf="customerPayoutForm.controls['customerPayoutDatetime'].touched && customerPayoutForm.controls['customerPayoutDatetime'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Payment Method
                                            </label>
                                            <span>
                                                <mat-form-field appearance="outline" class="select_panel">
                                               <mat-select matNativeControl formControlName="customerPayoutPaymentMethod">
                                                <mat-option *ngFor="let item of technicianAndCustomerPaymentMethod"
                                                    [value]="item?.value">{{item?.label}}</mat-option>
                                            </mat-select>
                                            <mat-error  *ngIf="customerPayoutForm.controls['customerPayoutPaymentMethod'].touched && customerPayoutForm.controls['customerPayoutPaymentMethod'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                            </mat-form-field>
                                            </span>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Transaction id
                                            </label>
                                            <span>
                                               <input formControlName="customerPayoutTransactionId"/> 
                                            </span>
                                            <mat-error  *ngIf="customerPayoutForm.controls['customerPayoutTransactionId'].touched && customerPayoutForm.controls['customerPayoutTransactionId'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                    </div>
                
                                </form>
                            </ng-container>
                        </div>
                        <div class="payout_panel">
                            <div class="panel_heading underline">
                                <h2>
                                    Customer Fees
                                </h2>
                                <div class="panel_editsection">
                                    <mat-icon *ngIf="editingTab !== allSections.CustomerFees" (click)="editSection(allSections.CustomerFees)" class="edit_icon">edit</mat-icon>
                                    <mat-icon *ngIf="editingTab === allSections.CustomerFees" (click)="cancelSection(allSections.CustomerFees)" class="cancel_icon">close</mat-icon>
                                    <mat-icon *ngIf="editingTab === allSections.CustomerFees" (click)="saveSection(allSections.CustomerFees)" class="done_icon">done</mat-icon>
                                </div>
                                </div>
                            <div *ngIf="editingTab !== allSections.CustomerFees" class="claim_showprt">
                                <div class="claim_inputprt">
                                    <label>
                                        Additional Fees
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.customerFees | currency}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Copayment Fees
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.copaymentFee | currency}}
                                    </p>
                                </div>

                                
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Notes
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.customerFeesNote}}
                                    </p>
                                </div>
                            </div>
                            <ng-container  *ngIf="editingTab === allSections.CustomerFees">
                                <form [formGroup]="customerFeesForm">
                                    <div class="claim_showprt">
                                        <div class="claim_inputprt">
                                            <label>
                                                Additional Fees
                                            </label>
                                            <span>
                                                <input formControlName="customerFees"  mask="separator.2" prefix="$" thousandSeparator=","/>
                                            </span>
                                            <mat-error  *ngIf="customerFeesForm.controls['customerFees'].touched && customerFeesForm.controls['customerFees'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                        <div class="claim_inputprt">
                                            <label>
                                                Copayment Fees
                                            </label>
                                            <p>
                                                {{claimDetails?.claim?.copaymentFee | currency}}
                                            </p>
                                        </div>
                                        <div class="claim_inputprt full-width">
                                            <label>
                                                Notes
                                            </label>
                                            <span>
                                                
                                                <textarea formControlName="customerFeesNote"></textarea>
                                            </span>
                                            <mat-error  *ngIf="customerFeesForm.controls['customerFeesNote'].touched && customerFeesForm.controls['customerFeesNote'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </div>
                                    </div>
                
                                </form>
                            </ng-container>
                        </div>
                        <div class="payout_panel">
                            <h2 class="underline">
                                Total Payout
                            </h2>
                            <div class="claim_showprt">
                                <div class="claim_inputprt">
                                    <label>
                                        Payout
                                    </label>
                                    <p>
                                        {{claimDetails?.claim?.claimPayout?.totalPayout | currency}}
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="gap"></div>
                    <div  class="payout_panel" *ngIf="claimDetails?.claim?.claimReplacement?.length === 0">
                        <div class="panel_heading underline claimwrap">
                            <h2>
                                Replacement
                            </h2>
                            <div class="panel_editsection">
                                <button class="add_button" mat-stroked-button  (click)="openActionModal('orderReplacement')"><mat-icon>add_circle</mat-icon> Add Replacement</button>
                            </div>
                        </div>
                        <div class="claim_showprt">
                            No data found
                        </div>
        
                    </div>
      
                    
                    <div class="payout_panel" *ngFor="let item of claimDetails?.claim?.claimReplacement;  index as i">
                        <div class="panel_heading underline claimwrap">
                            <h2>
                                Replacement - <span>[{{i+1}}]</span>
                            </h2>
                            <div class="panel_editsection">
                                <mat-icon *ngIf="editingTab !== allSections.Replacement + i" (click)="editSection(allSections.Replacement + i, item)" class="edit_icon">edit</mat-icon>
                                <mat-icon *ngIf="editingTab === allSections.Replacement + i" (click)="cancelSection(allSections.Replacement + i)" class="cancel_icon">close</mat-icon>
                                <mat-icon *ngIf="editingTab === allSections.Replacement + i" (click)="updateOrderReplacement(item?.claimReplacementId)" class="done_icon">done</mat-icon>
                            </div>
                            <button class="add_button" mat-stroked-button (click)="openActionModal('orderReplacement')" ><mat-icon>add_circle</mat-icon>Add Replacement</button>
                        </div>
                   
                    <div *ngIf="editingTab !== allSections.Replacement + i" class="claim_showprt">

                        <div class="claim_inputprt">
                            <label>
                                Ordered from
                            </label>
                            <p>
                                {{item?.orderedFrom}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Order Date
                            </label>
                            <p>
                                {{ commonService.convertDate(item?.orderedDate)  |  date : 'MMM dd, YYYY'}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Tracking #
                            </label>
                            <p>
                                {{item?.tracking}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Delivery Date
                            </label>
                            <p>
                                {{ commonService.convertDate(item?.deliveryDate)  |  date : 'MMM dd, YYYY'}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Item Type
                            </label>
                            <p>
                                {{item?.itemType}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Assigned Technician
                            </label>
                            <p>
                                {{commonService.getFullName(item?.assignedTechnician?.firstName,
                                    item?.assignedTechnician?.lastName)}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Technician contact
                            </label>
                            <p>
                        {{item?.assignedTechnician?.phoneNumber | mask: '(000) 000-0000'}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Age of Item
                            </label>
                            <p>
                        {{item?.ageOfItem}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Brand
                            </label>
                            <p>
                        {{item?.brand}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Model #
                            </label>
                            <p>
                        {{item?.model}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Serial #
                            </label>
                            <p>
                        {{item?.serial}}
                            </p>
                        </div>

                        
                        <div class="claim_inputprt">
                            <label>
                                Color
                            </label>
                            <p>
                        {{item?.color}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Size
                            </label>
                            <p>
                        {{item?.size}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Hallaway
                            </label>
                            <p>
                        {{item?.hallaway ? "Yes" : "No"}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Item Cost
                            </label>
                            <p>
                        {{item?.itemCost | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Installation cost
                            </label>
                            <p>
                        {{item?.installationCost | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Hallaway Cost
                            </label>
                            <p>
                        {{item?.hallawayCost | currency}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Total cost
                            </label>
                            <p>
                        {{item?.totalCost | currency}}
                            </p>
                        </div>

                       

                        <div class="claim_inputprt">
                            <label>
                                Outcome
                            </label>
                            <p>
                        {{item?.outcome}}
                            </p>
                        </div>
                        <div class="claim_inputprt full-width">
                            <label>
                                Notes
                            </label>
                            <p>
                        {{item?.notes}}
                            </p>
                        </div>
                        <div class="claim_inputprt full-width">
                            <label>
                                Completed Note
                            </label>
                            <p>
                        {{item?.completedNote}}
                            </p>
                        </div>
                        
                    </div>
                    <ng-container  *ngIf="editingTab === allSections.Replacement + i">
                        <form [formGroup]="orderReplacementForm">
                            <div class="claim_showprt">
                                <div class="claim_inputprt">
                                    <label>
                                        Ordered from
                                    </label>
                                    <span>
                                       <input formControlName="orderedFrom" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['orderedFrom'].touched && orderReplacementForm.controls['orderedFrom'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Order Date
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline"  class="select_panel">
                                            <!-- <mat-label>Order Date</mat-label> -->
                                            <input matInput [matDatepicker]="picker" formControlName="orderedDate" (click)="picker.open()" readonly [min]="datePicker?.minDate">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                            <mat-error  *ngIf="orderReplacementForm.controls['orderedDate'].touched && orderReplacementForm.controls['orderedDate'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </mat-form-field>
                                    </span>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Tracking #
                                    </label>
                                    <span>
                                       <input formControlName="tracking" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['tracking'].touched && orderReplacementForm.controls['tracking'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Delivery Date
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline"  class="select_panel">
                                            <!-- <mat-label>Order Date</mat-label> -->
                                            <input matInput [matDatepicker]="picker1" formControlName="deliveryDate" (click)="picker1.open()" readonly [min]="datePicker?.minDate">
                                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                            <mat-datepicker #picker1></mat-datepicker>
                                            <mat-error  *ngIf="orderReplacementForm.controls['deliveryDate'].touched && orderReplacementForm.controls['deliveryDate'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </mat-form-field>
                                    </span>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                      Item Type
                                    </label>
                                    <span>
                                       <input formControlName="itemType" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['itemType'].touched && orderReplacementForm.controls['itemType'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Assigned Technician
                                    </label>
                                    <p>
                                        {{commonService.getFullName(item?.assignedTechnician?.firstName,
                                            item?.assignedTechnician?.lastName)}}
                                    </p>
                                </div>
        
                                <div class="claim_inputprt">
                                    <label>
                                        Technician contact
                                    </label>
                                    <p>
                                {{item?.assignedTechnician?.phoneNumber | mask: '(000) 000-0000'}}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Age of Item
                                    </label>
                                    <span>
                                       <input formControlName="ageOfItem" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['ageOfItem'].touched && orderReplacementForm.controls['ageOfItem'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Brand
                                    </label>
                                    <span>
                                       <input formControlName="brand" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['brand'].touched && orderReplacementForm.controls['brand'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Model #
                                    </label>
                                    <span>
                                       <input formControlName="model" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['model'].touched && orderReplacementForm.controls['model'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Serial #
                                    </label>
                                    <span>
                                       <input formControlName="serial" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['serial'].touched && orderReplacementForm.controls['serial'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Color
                                    </label>
                                    <span>
                                       <input formControlName="color" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['color'].touched && orderReplacementForm.controls['model'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                       Size
                                    </label>
                                    <span>
                                       <input formControlName="size" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['size'].touched && orderReplacementForm.controls['size'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Hallaway
                                    </label>
                                    <span>
                                        <mat-form-field appearance="outline" class="select_panel">
                                       <mat-select matNativeControl formControlName="hallaway">
                                        <mat-option [value]="true">Yes</mat-option>
                                        <mat-option [value]="false">No</mat-option>
                                    </mat-select>
                                    </mat-form-field>
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['hallaway'].touched && orderReplacementForm.controls['hallaway'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Item Cost
                                    </label>
                                    <span>
                                       <input formControlName="itemCost"  mask="separator.2" prefix="$" thousandSeparator=","/> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['itemCost'].touched && orderReplacementForm.controls['itemCost'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Installation Cost
                                    </label>
                                    <span>
                                       <input formControlName="installationCost"  mask="separator.2" prefix="$" thousandSeparator=","/> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['installationCost'].touched && orderReplacementForm.controls['installationCost'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Hallaway Cost
                                    </label>
                                    <span>
                                       <input formControlName="hallawayCost"  mask="separator.2" prefix="$" thousandSeparator=","/> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['hallawayCost'].touched && orderReplacementForm.controls['hallawayCost'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Outcome
                                    </label>
                                    <span>
                                       <input formControlName="outcome" /> 
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['outcome'].touched && orderReplacementForm.controls['outcome'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>

                                <div class="claim_inputprt full-width">
                                    <label>
                                        Note
                                    </label>
                                    <span>
                                         <textarea formControlName="notes"></textarea>
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['notes'].touched && orderReplacementForm.controls['notes'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                <div class="claim_inputprt full-width">
                                    <label>
                                        Completed Note
                                    </label>
                                    <span>
                                         <textarea formControlName="completedNote"></textarea>
                                    </span>
                                    <mat-error  *ngIf="orderReplacementForm.controls['completedNote'].touched && orderReplacementForm.controls['completedNote'].hasError('required')">
                                        This is required field.
                                    </mat-error>
                                </div>
                                
                            </div>
        
                        </form>
                    </ng-container>
                    </div>
                        <div class="gap"></div>
                        <div class="panel_heading underline claimwrap">
                            <h2>
                                Notes History
                            </h2>
                            <button class="add_button" mat-stroked-button (click)="handleAddNotes()"><mat-icon>add_circle</mat-icon>Add Notes</button>
                        </div>
                       
                        <div>
    
                            <fury-list>
                                <div class="table">
                                    <table mat-table [dataSource]="noteHistory">
    
    
                                        <!--  status Column -->
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef>Note Status</th>
                                            <td mat-cell *matCellDef="let element">
                                                {{ element?.status }}
                                            </td>
                                        </ng-container>
    
                                        <!-- Assigned Column -->
                                        <ng-container matColumnDef="assigned">
                                            <th mat-header-cell *matHeaderCellDef>Assigned</th>
                                            <td mat-cell *matCellDef="let element">
                                                {{commonService.getFullName( element?.assigned?.firstName,
                                                element?.assigned?.lastName)}}
    
                                        </ng-container>
    
    
                                        <!-- Agreement Number -->
                                        <ng-container matColumnDef="agreementNumber">
                                            <th mat-header-cell *matHeaderCellDef>Agreement Number</th>
                                            <td mat-cell *matCellDef="let element">
                                                {{ element?.agreementNumber }}
                                            </td>
                                        </ng-container>
    
                                        <!-- createdOn Column  -->
                                        <ng-container matColumnDef="createdOn">
                                            <th mat-header-cell *matHeaderCellDef>Created on</th>
                                            <td mat-cell *matCellDef="let element">
                                                {{ commonService.convertDate(element?.createdOn)   | date : 'MMM dd, YYYY'}}
                                            </td>
                                        </ng-container>
    
    
    
                                        <!-- createdBy Column -->
                                        <ng-container matColumnDef="createdBy">
                                            <th mat-header-cell *matHeaderCellDef>Created By</th>
                                            <td mat-cell *matCellDef="let element">
                                                {{commonService.getFullName( element?.createdBy?.firstName,
                                                element?.createdBy?.lastName)}}
                                              
                                            </td>
                                        </ng-container>
    
    
    
                                        <!-- Priority Column -->
                                        <ng-container matColumnDef="priority">
                                            <th mat-header-cell *matHeaderCellDef>Priority</th>
                                            <td mat-cell *matCellDef="let element">
                                                {{ element?.priority }}
                                            </td>
                                        </ng-container>
    
                                        <!-- notes Column -->
                                        <ng-container matColumnDef="notes">
                                            <th class="request_section" mat-header-cell *matHeaderCellDef>Request</th>
                                            <td class="request_section" mat-cell *matCellDef="let element">
                                                <div class="maxTxt">
                                                    {{ element?.notes}}
                                                </div>
                                               
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="actions" stickyEnd>
                                            <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                                            <td *matCellDef="let row; let i = index" class="actions-cell" mat-cell>
                                              <button
                                                type="button"
                                                mat-icon-button
                                                [matMenuTriggerFor]="actionsMenu"
                                                (click)="$event.stopPropagation()"
                                              >
                                                <mat-icon>more_horiz</mat-icon>
                                              </button>
                                              <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                                                <button mat-menu-item (click)="handleEditNotes(row)" >
                                                  <span>Edit</span>
                                                </button>
                                                <button mat-menu-item (click)="handleViewNotes(row)" >
                                                  <span>View</span>
                                                </button>
                                              </mat-menu>
                                            </td>
                                          </ng-container>
    
    
    
    
                                        <tr mat-header-row *matHeaderRowDef="displayedNotesColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedNotesColumns"></tr>
                                    </table>
                                    <div class="no-data" *ngIf="!noteHistory?.length" style="padding: 10px 0; text-align: center">
                                        No data found.
                                    </div>
                                </div>
                            </fury-list>
                        </div>

                        <div class="gap"></div>
                        <div class="panel_heading underline claimwrap">
                            <h2>
                                Special Requests History
                            </h2>
                            <button class="add_button" mat-stroked-button (click)="handleAddSpecialRequest()" ><mat-icon>add_circle</mat-icon>Add Special Request</button>
                        </div>
                    
                    <div>
                        <fury-list>
                            <div class="table">
                                <table mat-table [dataSource]="specialRequestHistory">


                                    <!--  status Column -->
                                    <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef>Request Status</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element?.status }}
                                        </td>
                                    </ng-container>

                                    <!-- Assigned Column -->
                                    <ng-container matColumnDef="assigned">
                                        <th mat-header-cell *matHeaderCellDef>Assigned User</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{commonService.getFullName( element?.assigned?.firstName,
                                            element?.assigned?.lastName)}}

                                    </ng-container>


                                    <!-- Agreement Number -->
                                    <ng-container matColumnDef="agreementNumber">
                                        <th mat-header-cell *matHeaderCellDef>Agreement Number</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element?.agreementNumber }}
                                        </td>
                                    </ng-container>

                                    <!-- createdOn Column -->
                                    <ng-container matColumnDef="createdOn">
                                        <th mat-header-cell *matHeaderCellDef>Created on</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ commonService.convertDate(element?.createdOn) | date : 'MMM dd, YYYY'}}
                                        </td>
                                    </ng-container>


                                    <!-- createdBy Column -->
                                    <ng-container matColumnDef="createdBy">
                                        <th mat-header-cell *matHeaderCellDef>Created By</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{commonService.getFullName( element?.createdBy?.firstName,
                                            element?.createdBy?.lastName)}}
                                        </td>
                                    </ng-container>



                                    <!-- type Column -->
                                    <ng-container matColumnDef="type">
                                        <th mat-header-cell *matHeaderCellDef>Request Type</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element?.type }}
                                        </td>
                                    </ng-container>

                                    <!-- Priority Column -->
                                    <ng-container matColumnDef="priority">
                                        <th mat-header-cell *matHeaderCellDef>Priority</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element?.priority }}
                                        </td>
                                    </ng-container>

                                    <!-- notes Column -->
                                    <ng-container matColumnDef="request">
                                        <th class="request_section" mat-header-cell *matHeaderCellDef>Request</th>
                                        <td class="request_section" mat-cell *matCellDef="let element">
                                            <div class="maxTxt">
                                                {{ element?.request}}
                                            </div>
                                           
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="actions" stickyEnd>
                                        <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                                        <td *matCellDef="let row; let i = index" class="actions-cell" mat-cell>
                                          <button
                                            type="button"
                                            mat-icon-button
                                            [matMenuTriggerFor]="actionsMenu"
                                            (click)="$event.stopPropagation()"
                                          >
                                            <mat-icon>more_horiz</mat-icon>
                                          </button>
                                          <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                                            <button mat-menu-item (click)="handleEditRequest(row)" >
                                              <span>Edit</span>
                                            </button>
                                            
                                            <button mat-menu-item (click)="handleViewRequest(row)">
                                              <span>View</span>
                                            </button>
                                          </mat-menu>
                                        </td>
                                      </ng-container>

       

                                    <tr mat-header-row *matHeaderRowDef="displayedRequestColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedRequestColumns"></tr>
                                </table>
                                <div class="no-data" *ngIf="!specialRequestHistory?.length" style="padding: 10px 0; text-align: center">
                                    No data found.
                                </div>
                            </div>
                        </fury-list>

                    </div>

                    <div class="gap"></div>
                    <div class="panel_heading underline claimwrap">
                        <h2>Feedback History</h2>
                        <button class="add_button" mat-stroked-button (click)="handleAddFeedback()" ><mat-icon>add_circle</mat-icon>Add Feedback</button>
                    </div>
                   
                    <div>

                        <fury-list>
                            <div class="table">
                              <table mat-table [dataSource]="feedbackHistory">
                                <!--- Note that these columns can be defined in any order.
                                            The actual rendered columns are set as a property on the row definition" -->
                          
                               <!-- Assigned feedback Column -->
                                <ng-container matColumnDef="feedback">
                                  <th mat-header-cell *matHeaderCellDef>Feedback Rating</th>
                                  <td mat-cell *matCellDef="let element">
                                    {{ element?.feedback }}
                                  </td>
                                </ng-container>
                          
                                   <!-- reviewStatus Column -->
                                   <ng-container matColumnDef="reviewStatus">
                                    <th mat-header-cell *matHeaderCellDef>Feedback Status</th>
                                    <td mat-cell *matCellDef="let element">{{ element?.reviewStatus }}</td>
                                  </ng-container>
                          
                                     <!-- Assigned -->
                                <ng-container matColumnDef="assigned">
                                  <th mat-header-cell *matHeaderCellDef>Assigned</th>
                                  <td mat-cell *matCellDef="let element">
                                    {{ commonService.getFullName(element?.reviewDetails?.assigned?.firstName, element?.reviewDetails?.assigned?.lastName) }}
                            
                                  </td>
                                </ng-container>
                          
                                   <!-- Agreement Number -->
                                <ng-container matColumnDef="agreementNumber">
                                  <th mat-header-cell *matHeaderCellDef>Agreement Number</th>
                                  <td mat-cell *matCellDef="let element">
                                    {{ element?.reviewDetails?.agreementNumber }}
                                  </td>
                                </ng-container>
                          
                                <!-- feedback reviewSubmittedAt Column -->
                                <ng-container matColumnDef="reviewSubmittedAt">
                                  <th mat-header-cell *matHeaderCellDef>Created on</th>
                                  <td mat-cell *matCellDef="let element">
                                    {{ commonService.convertDate(element?.reviewSubmittedAt)  | date : 'MMM dd, YYYY' }}
                                  </td>
                                </ng-container>
                          
                          
                                    
                                     <!-- feedback createdBy Column -->
                                     <ng-container matColumnDef="createdBy">
                                      <th mat-header-cell *matHeaderCellDef>Created By</th>
                                      <td mat-cell *matCellDef="let element">
                                        {{ commonService.getFullName(element?.reviewDetails?.createdBy?.firstName, element?.reviewDetails?.createdBy?.lastName) }}
                                      </td>
                                    </ng-container>
                          
                                      <!-- feedback reviewSubmittedAt Column -->
                                      <ng-container matColumnDef="priority">
                                        <th mat-header-cell *matHeaderCellDef>Priority</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ element?.reviewDetails?.priority }}
                                        </td>
                                      </ng-container>
                          
                                          <!-- feedback Request Column -->
                                          <ng-container matColumnDef="request">
                                            <th class="request_section" mat-header-cell *matHeaderCellDef>Request</th>
                                            <td class="request_section" mat-cell *matCellDef="let element">
                                              {{ element?.reviewDetails?.request }}
                                            </td>
                                          </ng-container>

                                          <ng-container matColumnDef="actions" stickyEnd>
                                            <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                                            <td *matCellDef="let row; let i = index" class="actions-cell" mat-cell>
                                              <button
                                                type="button"
                                                mat-icon-button
                                                [matMenuTriggerFor]="actionsMenu"
                                                (click)="$event.stopPropagation()"
                                              >
                                                <mat-icon>more_horiz</mat-icon>
                                              </button>
                                              <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                                                <button mat-menu-item  (click)="handleEditFeedback(row)">
                                                  <span>Edit</span>
                                                </button>
                                                <button mat-menu-item (click)="handleViewFeedback(row)">
                                                  <span>View</span>
                                                </button>
                                              </mat-menu>
                                            </td>
                                          </ng-container>
                              
                        
                          
                                <tr mat-header-row *matHeaderRowDef="displayedFeedbackColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedFeedbackColumns"></tr>
                              </table>
                              <div class="no-data"
                                *ngIf="!feedbackHistory.length"
                                style="padding: 10px 0; text-align: center"
                              >
                                No data found.
                              </div>
                            </div>
                          </fury-list>
                          
                    </div>

                    <div class="gap"></div>
                    <h2 class="underline">Transaction History</h2>

                    <div>

                        <fury-list>
                            <div class="table">
                              <table mat-table [dataSource]="[claimDetails?.claim?.paymentDetails]">
                                
                               <!-- Assigned transactionId Column -->
                                <ng-container matColumnDef="transactionId">
                                  <th mat-header-cell *matHeaderCellDef>Transaction Id</th>
                                  <td mat-cell *matCellDef="let element">
                                    {{ element?.transactionId }}
                                  </td>
                                </ng-container>

                                    <!-- Assigned amount Column -->
                                    <ng-container matColumnDef="amount">
                                        <th mat-header-cell *matHeaderCellDef>Amount</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ element?.amount | currency }}
                                        </td>
                                      </ng-container>

                                          <!-- Assigned cardType Column -->
                                    <ng-container matColumnDef="cardType">
                                        <th mat-header-cell *matHeaderCellDef>Card Type</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ element?.cardType }}
                                        </td>
                                      </ng-container>

                                               <!-- Assigned lastFourDigit Column -->
                                    <ng-container matColumnDef="lastFourDigit">
                                        <th mat-header-cell *matHeaderCellDef>Last Four Digits</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ element?.lastFourDigit }}
                                        </td>
                                      </ng-container>
                          
                          
                    
                        
                          
                                <tr mat-header-row *matHeaderRowDef="displayedPaymentDetailsColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedPaymentDetailsColumns"></tr>
                              </table>
                              <div class="no-data"
                                *ngIf="![claimDetails?.claim?.paymentDetails]?.length"
                                style="padding: 10px 0; text-align: center"
                              >
                                No data found.
                              </div>
                            </div>
                          </fury-list>
                          
                    </div>
                    <fury-document-center-table [userId]="userId" [shouldRefetchDocuments]="shouldRefetchDocuments" [claimId]="claimId"></fury-document-center-table>
                    <div class="gap"></div>
                    <div class="log">
                        <fury-claim-changes-log-modal [fileClaimId]="claimId"></fury-claim-changes-log-modal>
                    </div>
                </div>


            </div>
        </div>
    </fury-page-layout-content>
</fury-page-layout>